import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const initialState = {
  id: '',
  current_user: {},
  logged_in: false,
  timeout: false,
  haveFormData: false,
  showFormModal: false,
  navigateValue: '',
  hasUnsavedChanges: false,
  isSaving: false,
  isAutoSaving: false,
  autoSaveField: null
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setUser: (state, action) => {
      state = { ...state, ...action.payload }
      return state
    },
    setFormDirty: (state, action) => {
      state = { ...state, ...action.payload }
      return state
    },
    setShowFormModal: (state, action) => {
      state = { ...state, ...action.payload }
      return state
    },
    setNavigateValue: (state, action) => {
      state = { ...state, ...action.payload }
      return state
    },
    setHasUnsavedChanges: (state, action) => {
      state.hasUnsavedChanges = action.payload
      return state
    },
    setIsSaving: (state, action) => {
      state.isSaving = action.payload
      return state
    },
    setAutoSaving: (state, action) => {
      state.isAutoSaving = action.payload.isAutoSaving
      state.autoSaveField = action.payload.field || null
      return state
    },
    clearUnsavedChanges: (state) => {
      state.hasUnsavedChanges = false
      return state
    }
  }
})

export const { 
  setUser, 
  setFormDirty, 
  setShowFormModal, 
  setNavigateValue, 
  setHasUnsavedChanges, 
  setIsSaving,
  setAutoSaving,
  clearUnsavedChanges 
} = userSlice.actions

export default userSlice.reducer
